import axios from "axios";
import React, { useEffect, useState } from "react";
import styles from "./styles.css";
import Select from "react-select";
// reactstrap components
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  CardTitle,
  FormGroup,
  Form,
  Input,
  Row,
  Col,
  Label,
} from "reactstrap";
import { URL_API } from "variable";
import { Editor } from "react-draft-wysiwyg";
import { EditorState } from "draft-js";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { useHistory } from "react-router-dom";

import { toast } from "react-toastify";
import { useParams } from "react-router-dom";


toast.configure();

function PermissionEdit() {
  const modules = {
    toolbar: [
      [{ header: [1, 2, 3, 4, 5, 6, false] }],
      [{ font: [] }],
      ["bold", "italic", "underline", "strike", "blockquote"],
      [
        { list: "ordered" },
        { list: "bullet" },
        { indent: "-1" },
        { indent: "+1" },
      ],
      ["link", "image"],
      ["clean"],
      [{ align: [] }],
      ["code-block"],
    ],
  };

  const formats = [
    "header",
    "font",
    "bold",
    "italic",
    "underline",
    "strike",
    "blockquote",
    "list",
    "bullet",
    "indent",
    "link",
    "image",
    "align",
    "code-block",
  ];

  const [editorState, setEditorState] = useState(() =>
    EditorState.createEmpty()
  );
  const history = useHistory();
  const [title, setTitle] = useState();
  const [value, setValue] = useState();
  const [image, setImage] = useState();
  const id = useParams();


  useEffect(() => {
    getPermision();
    let token = localStorage.getItem("token");
  }, []);

  const onTitleChange = (e) => {
    setTitle([e.target.value]);
  };
  const onValueChange = (e) => {
    setValue([e.target.value]);
  };


  
  const getPermision = () => {
    axios
      .get(URL_API + `auth/admin/permissions/${id.id}/edit`)
      .then((response) => {
        if (response?.status == 200) {
          setTitle(response?.data?.permission?.name);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };



  const onSubmit = (event) => {
    event.preventDefault();

    let formData = new FormData();
      formData.append("name", title);
      // formData.append("value", value);

      axios
        .post(URL_API + `auth/admin/update-permission/${id.id}`, formData)
        .then((response) => {
          if (response.status == 200) {
            history.push("/admin/Permissions");
            toast.success("Permission Updated Successfully", {
              position: toast.POSITION.TOP_RIGHT,
              autoClose: 2000,
            });
          }
        })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <>
      <div className="content">
        <form onSubmit={(e) => onSubmit(e)}>
          <div className={`container-fluid`}>
            <div className={styles.HeroiImgBlogForm}>
              <div className={styles.paddingTopBottomBlogForm}>
                <h3 className={styles.HeroiImgTextBlogForm}>Update Permission</h3>
              </div>
            </div>
            <br />
            <div className="container">
              <div className={`form ${styles.blogPostForm}`}>
                <div className="form-group">
                  <label htmlFor="post-title" className={styles.labelPostForm}>
                    Title
                  </label>
                  <Input
                    name="phone"
                    type="text"
                    value={title}
                    id="post-title"
                    required="required"
                    onChange={(e) => onTitleChange(e)}
                  />
                </div>
                <br />
             
                <Input
                  type="submit"
                  name="submit"
                  className={`btn btn-danger ${styles.blogPostFormBtn}`}
                  value="Submit"
                />
              </div>
              <br />
              <br />
            </div>
          </div>
          {/* <BlogForm handleChange={handleChange} /> */}
        </form>
      </div>
    </>
  );
}

export default PermissionEdit;
